import * as React from "react";
import { Button, IconNames } from "@focus/focusUI";
export const CustomHeader = ({ setOpen, progressSort, column, api, displayName, disableEdition, setSelectedColumn, position, }) => {
    const handleClickedEdit = () => {
        setSelectedColumn(position);
        setOpen(true);
    };
    const onSortClicked = () => {
        progressSort();
        api.refreshHeader();
    };
    let icon;
    if (column.getSort() === "asc") {
        icon = IconNames.CARET_UP;
    }
    else if (column.getSort() === "desc") {
        icon = IconNames.CARET_DOWN;
    }
    else {
        icon = IconNames.DOUBLE_CARET_VERTICAL;
    }
    return (React.createElement("div", { style: {
            overflow: "hidden",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
        } },
        displayName,
        React.createElement("div", null,
            React.createElement(Button, { icon: icon, minimal: true, small: true, onClick: onSortClicked, "aria-label": "buttonCustomHeader1" }),
            React.createElement(Button, { icon: "edit", minimal: true, onClick: handleClickedEdit, disabled: disableEdition, "aria-label": "buttonCustomHeader2" }))));
};
//# sourceMappingURL=CustomHeader.js.map